module.exports = __webpack_public_path__ + "static/assets/f61b4bb92eae22d69013b29704020f1e.png";